import { render, staticRenderFns } from "./TransactionReceipt.vue?vue&type=template&id=524b719c&scoped=true&"
import script from "./TransactionReceipt.vue?vue&type=script&lang=js&"
export * from "./TransactionReceipt.vue?vue&type=script&lang=js&"
import style0 from "./TransactionReceipt.vue?vue&type=style&index=0&id=524b719c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b719c",
  null
  
)

export default component.exports